import React from "react";
import { useNavigate } from "react-router-dom";
import Carousel from "../components/carousel";
import BrandDesignHero from "../components/brand-design-hero";
import ColorPalette from "../components/color-palette";
import ScrollToTopButton from "../components/scroll-to-top-btn";

import intro from "../assets/Kane FM Intro Video.mp4";
import logo from "../assets/kanefm-logo.png";
import kaneDesk from "../assets/kane-desk.jpg";
import turquoiseBg from "../assets/turquoise-bg.jpg";

import kaneInsta from "../assets/kane-insta.mp4";
import mindInsta from "../assets/mindwaves-insta.mp4";
import mindwavesSocials1 from "../assets/kane-socials1.png";
import mindwavesSocials2 from "../assets/kane-socials2.png";
import mindwavesSocials3 from "../assets/kane-socials3.png";
import mindwavesSocials4 from "../assets/kane-socials4.png";
import mindwavesSocials5 from "../assets/kane-socials5.png";
import mindwavesSocials6 from "../assets/kane-socials6.png";
import mindwavesSocials7 from "../assets/kane-socials7.png";
import kaneSocials1 from "../assets/KaneFM Insta Post 1.jpg";
import kaneSocials2 from "../assets/KaneFM Insta Post 2.jpg";
import kaneSocials3 from "../assets/KaneFM Insta Post 3.jpg";
import kaneSocials4 from "../assets/KaneFM Insta Post 4.jpg";
import kaneSocials5 from "../assets/KaneFM Insta Post 5.jpg";
import kaneSocials6 from "../assets/KaneFM Insta Post 6.jpg";
import kaneSocials7 from "../assets/KaneFM Insta Post 7.jpg";
import kaneSocials8 from "../assets/KaneFM Insta Post 8.jpg";
import kaneSocials9 from "../assets/KaneFM Insta Post 9.jpg";
import kaneSocials10 from "../assets/KaneFM Insta Post 10.jpg";
import kaneSocials11 from "../assets/KaneFM Insta Post 11.jpg";
import kaneSocials12 from "../assets/KaneFM Insta Post 12.jpg";
import kaneSocials13 from "../assets/KaneFM Insta Post 13.jpg";
import kaneSocials14 from "../assets/KaneFM Insta Post 14.jpg";
import kaneSocials15 from "../assets/KaneFM Insta Post 15.jpg";
import kaneSocials16 from "../assets/KaneFM Insta Post 16.jpg";
import kaneSocials17 from "../assets/KaneFM Insta Post 17.jpg";
import kaneSocials18 from "../assets/KaneFM Insta Post 18.jpg";
import kaneSocials19 from "../assets/KaneFM Insta Post 19.jpg";
import kaneSocials20 from "../assets/KaneFM Insta Post 20.jpg";

import website from "../assets/Kane-fm.mp4";

const KaneFM: React.FC = () => {
  const navigate = useNavigate();

  const colors = [
    { bgClass: "bg-turquoise", hexColor: "#94D4CD" },
    { bgClass: "bg-white", hexColor: "#FFFFFF" },
    { bgClass: "bg-black", hexColor: "#000000" },
  ];

  const kaneSocials = [kaneSocials1, kaneSocials2, kaneSocials3, kaneSocials4, kaneSocials5, kaneSocials6, kaneSocials7, kaneSocials8, kaneSocials9, kaneSocials10, kaneSocials11, kaneSocials12, kaneSocials13, kaneSocials14, kaneSocials15, kaneSocials16, kaneSocials17, kaneSocials18, kaneSocials19, kaneSocials20]
  const mindwavesSocials = [mindwavesSocials1, mindwavesSocials2, mindwavesSocials3, mindwavesSocials4, mindwavesSocials5, mindwavesSocials6, mindwavesSocials7];

  return (
    <div className="mx-10 md:mx-20 my-10">
      <button className="font-frank text-white text-lg hover:underline" onClick={() => navigate("/")}>← Back to Home</button>

      <h1 className="font-euro text-white text-3xl mt-8 mb-3">Kane FM</h1>
      <div className="border-t-4 border-orange"></div>
      <p className="text-white font-frankbook text-lg mt-5 mb-10">I was the Graphic Designer and Social Media Manager for Kane FM, leading the re-brand which launched in January 2024. Updating to a pastel colour palette with refreshed assets, I designed, wrote copy, and scheduled all social media posts on their two Instagram accounts - KaneFM and KaneMindWaves. Additionally, I made website updates and produced POS collateral. </p>

      <BrandDesignHero
        background={kaneDesk}
        logo={logo}
        name="Kane FM"
      />

      <ColorPalette background={turquoiseBg} colors={colors} />

      <h3 className="font-euro text-white text-2xl mt-6 mb-3">Brand Kit</h3>

      <table className="text-white text-lg lg:text-xl w-full mt-5">
        <tr>
          <td className="font-euro border-2 border-turquoise p-5">Typography</td>
          <td className="border-2 border-turquoise p-5">
            <p className="font-euro">Montserrat Classic Bold</p>
            <p className="font-frankbook">Montserrat Classic</p>
          </td>
        </tr>
        <tr>
          <td className="font-euro border-2 border-turquoise p-5">Colour Palette</td>
          <td className="border-2 border-turquoise p-5">
            <p className="font-frankbook"><strong>Turquoise - </strong>Clarity / Empathy / Protection</p>
            <p className="font-frankbook"><strong>White - </strong>Honesty / Beginnings / Simplicity</p>
            <p className="font-frankbook"><strong>Black - </strong>Formality / Strength</p>
          </td>
        </tr>
      </table>

      <video className="md:px-16 lg:px-40 my-8" autoPlay loop muted><source src={intro}></source></video>
      
      <h2 className="font-euro text-white text-center text-3xl mt-16 mb-3">Social Media Marketing</h2>
      <div className="border-t-2 border-orange"></div>

      <h2 className="font-euro text-white text-center text-2xl mt-8">Kane FM Social Media</h2>

      <div className="flex flex-col items-center justify-center mb-2">
        <Carousel images={kaneSocials} />
      </div>

      <a className="flex justify-center" href="https://www.instagram.com/kanefmuk/" target="_blank" rel="noreferrer">
      <button className="w-full bg-red hover:bg-lightOrange font-euro text-white py-2 mb-3">Visit Kane FM's Instagram</button>
      </a>
      <video className="md:px-14 lg:px-24" controls autoPlay muted><source src={kaneInsta}></source></video>

      <h2 className="font-euro text-white text-center text-2xl mt-12">MindWaves Social Media</h2>

      <div className="flex flex-col items-center justify-center mt-8 mb-14">
        <Carousel images={mindwavesSocials} />
      </div>

      <a className="flex justify-center" href="https://www.instagram.com/kanemindwaves/" target="_blank" rel="noreferrer">
      <button className="w-full bg-red hover:bg-lightOrange font-euro text-white py-2 mb-3">Visit the Mindwaves Instagram</button>
      </a>
      <video className="md:px-14 lg:px-24" controls autoPlay muted><source src={mindInsta}></source></video>

      <h2 className="font-euro text-white text-center text-3xl mt-16 mb-3">Website Management</h2>
      <div className="border-t-2 border-orange mb-8"></div>

      <video className="md:px-14 lg:px-24 mb-40" controls autoPlay muted><source src={website}></source></video>

      <ScrollToTopButton />
    </div>
  );
};

export default KaneFM;
